import React from "react";
import { Helmet } from "react-helmet";

import { GlobalStyle } from "./GlobalStyle";

const FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap";
const HTML_ATTRIBUTES = { lang: "en" };

const Layout = ({ children }) => {
  return (
    <>
      <Helmet htmlAttributes={HTML_ATTRIBUTES}>
        <title>Jason Li</title>
        <meta name="description" content="Jason Li - Software Developer" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href={FONT_HREF}
          media="print"
          onload="this.onload=null;this.removeAttribute('media');"
          rel="stylesheet"
        />
      </Helmet>
      <GlobalStyle />
      {children}
    </>
  );
};

export default Layout;
